import React from 'react';
import LeftTabbedGrayHeader from '../../../elements/headers/LeftTabbedGrayHeader';
import VerticalCenter from '../../../elements/VerticalCenter';
import Screen from '../../Screen';
import LiveVotingTopBar from '../common/LiveVotingTopBar';
import VoteAgain from '../common/VoteAgain/VoteAgain';

const AlreadyVoted = props => {
    const {event, question, i18n, resPath, onAnswerAgain} = props,
        header = <LiveVotingTopBar {...props} />,
        footer = <VoteAgain {...props} />;

    return (
        <Screen className="LiveVoting main" header={header} footer={footer}>
            <div
                className="fill-container "
                style={{
                    backgroundImage: 'url(' + resPath + 'img/live_vote_given.png)',
                    backgroundSize: 'cover',
                }}>
                <LeftTabbedGrayHeader
                    color="none"
                    style={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: 'auto',
                    }}>
                    {question.text}
                </LeftTabbedGrayHeader>
                <VerticalCenter>
                    <div className="content text-center well">
                        <h2>{i18n['livevoting.title-vote-given']}</h2>
                        {/*<hr /> // TEmp removed by Margriet request until we have better text
                                <h3>{i18n['livevoting.desc-vote-given']}</h3>*/}
                    </div>
                </VerticalCenter>
            </div>
        </Screen>
    );
};

export default AlreadyVoted;
